module.exports = __webpack_public_path__ + "bb4e6b4c6c7b16aa2df3fca0a57c68e2.svg";